module.exports = __webpack_public_path__ + "static/media/eventLive-logo.svg";